<template>
  <div>Step Field</div>
</template>

<script type="text/javascript">
import form_field from "../../../mixin/form-field.js";
export default {
  name: "form_step_field",
  mixins: [form_field],
};
</script>
